/**
 * PreviewLightbox — public-side click-to-zoom for an uploaded document.
 * Always renders a single image src (PDF first page is pre-rendered to PNG
 * upstream, so we can treat both image and PDF previews uniformly).
 */
import React, { useEffect } from 'react';
import { X } from '@phosphor-icons/react';

export function PreviewLightbox({ url, filename, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!url) return null;
  return (
    <div onClick={onClose}
      className="fixed inset-0 z-[95] flex items-center justify-center p-4 backdrop-blur-md"
      style={{ background: 'rgba(0,0,0,0.92)' }}
      data-testid="onboarding-lightbox">
      <button onClick={onClose}
        className="absolute top-4 right-4 p-2 rounded-lg transition-all hover:scale-110"
        style={{ background: 'rgba(255,255,255,0.12)', color: '#fff' }}
        data-testid="onboarding-lightbox-close">
        <X size={18} weight="bold" />
      </button>
      {filename && (
        <div className="absolute top-4 left-4 text-sm font-bold max-w-[60vw] truncate"
          style={{ color: '#fff' }}>
          {filename}
        </div>
      )}
      <img src={url} alt={filename || 'document'}
        onClick={(e) => e.stopPropagation()}
        className="max-w-[92vw] max-h-[88vh] object-contain rounded-xl shadow-2xl"
        data-testid="onboarding-lightbox-image" />
    </div>
  );
}
